import { IItem } from "../../types/CommonTypes";
import { v4 as uuidv4 } from "uuid";

export const getImageById = (id: string, item: IItem) => {
	return item.images.find((image) => image.id === id)?.url;
};

export const getTextById = (id: string, item: IItem) => {
	return item.texts.find((text) => text.id === id)?.text;
};

export const getCurrentDate = () => {
	const today = new Date();
	return today.toISOString();
};

export function formatDate(initialDate: string): string {
	console.log("REceived", initialDate);
	const format: string = "DD-MM-YYYY - HH:MM";

	const date: Date = new Date(initialDate);

	const day: number = date.getDate();
	const month: number = date.getMonth() + 1;
	const year: number = date.getFullYear();
	const hours: number = date.getHours();
	const minutes: number = date.getMinutes();

	const formattedDate: string = format
		.replace("DD", day < 10 ? "0" + day : day.toString())
		.replace("MM", month < 10 ? "0" + month : month.toString())
		.replace("YYYY", year.toString())
		.replace("HH", hours < 10 ? "0" + hours : hours.toString())
		.replace("MM", minutes < 10 ? "0" + minutes : minutes.toString());

	console.log("Returned", formattedDate);
	return formattedDate;
}

export function getRandomId() {
	return uuidv4();
}

export function getIdByUrl(url: string) {
	// Expresión regular para extraer el ID del video
	var regex =
		/(?:\?v=|\/embed\/|\/\d+\/|\/embed\/|youtu.be\/|\/v\/|\/e\/|\/u\/\w+\/|\/embed\/|\/v\/|\/watch\?v=|&v=)([^#\&\?\/\s]{11})/;

	// Intenta hacer coincidir la expresión regular con la URL proporcionada
	var coincidencia = url.match(regex);

	// Si se encontró una coincidencia, devuelve el ID del video
	if (coincidencia && coincidencia[1]) {
		return coincidencia[1];
	} else {
		// Si no se encontró una coincidencia, devuelve un valor nulo o puede manejar el error de otra manera
		return null;
	}
}

const PAGINATION_ROWS_PER_PAGE = [10, 20, 30, 40, 50];
const PAGINATION_TRANSLATE = {
	rowsPerPageText: "Filas por página:",
	rangeSeparatorText: "de",
	noRowsPerPage: false,
	selectAllRowsItem: false,
	selectAllRowsItemText: "All",
};

//CAROUSEL CONFIG
const CAROUSEL_CONFIG = {
	dots: true,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 5000,
	dotsClass: "slick-dots",
};

export const calculateSlug = (title: string) => {
	return title
		.toLowerCase()
		.replace(/ /g, "-")
		.replace(/[^\w-]+/g, "")
		.trim();
};

export const formatedDate = (isoDateString: string): string => {
	const date = parseDate(isoDateString);
	if (!date) return isoDateString ?? "";

	const day = date.getDate().toString().padStart(2, "0"); // Asegura el formato de dos dígitos
	const year = date.getFullYear();

	// Lista de nombres de meses en español
	const months = [
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"Mayo",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre",
	];
	const month = months[date.getMonth()];

	return `${day} de ${month} ${year}`;
};

export { PAGINATION_ROWS_PER_PAGE, PAGINATION_TRANSLATE, CAROUSEL_CONFIG };

/**
 * Convierte a Date los distintos formatos de fecha que existen en la base:
 * - ISO ("2024-05-12T10:33:00.000Z")
 * - "DD-MM-YYYY - HH:mm" (formato antiguo guardado por formatDate)
 * - "DD/MM/YYYY"
 * - Timestamp de Firestore ({ seconds, nanoseconds } o con .toDate())
 * Devuelve null cuando el valor no representa una fecha válida.
 */
export const parseDate = (value: any): Date | null => {
	if (!value) return null;

	if (value instanceof Date) {
		return isNaN(value.getTime()) ? null : value;
	}

	// Timestamp de Firestore
	if (typeof value === "object") {
		if (typeof value.toDate === "function") {
			const converted = value.toDate();
			return isNaN(converted.getTime()) ? null : converted;
		}
		if (typeof value.seconds === "number") {
			return new Date(value.seconds * 1000);
		}
		return null;
	}

	if (typeof value === "number") {
		const fromNumber = new Date(value);
		return isNaN(fromNumber.getTime()) ? null : fromNumber;
	}

	if (typeof value !== "string") return null;

	const raw = value.trim();

	// "YYYY-MM-DD" sin hora: new Date() lo interpretaría como medianoche UTC
	// y al formatear con getters locales la fecha se corre un día hacia atrás.
	const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (dateOnly) {
		const [, year, month, day] = dateOnly;
		return new Date(Number(year), Number(month) - 1, Number(day));
	}

	// "DD-MM-YYYY - HH:mm" | "DD/MM/YYYY - HH:mm" | "DD-MM-YYYY"
	const legacy = raw.match(
		/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})(?:\s*-\s*(\d{1,2}):(\d{1,2}))?$/
	);
	if (legacy) {
		const [, day, month, year, hours, minutes] = legacy;
		const parsed = new Date(
			Number(year),
			Number(month) - 1,
			Number(day),
			Number(hours ?? 0),
			Number(minutes ?? 0)
		);
		return isNaN(parsed.getTime()) ? null : parsed;
	}

	const parsed = new Date(raw);
	return isNaN(parsed.getTime()) ? null : parsed;
};

/** Milisegundos de la fecha, o 0 cuando no se puede interpretar. */
export const getDateTime = (value: any): number => {
	const parsed = parseDate(value);
	return parsed ? parsed.getTime() : 0;
};

/** Ordena una lista de más reciente a más antigua usando los campos indicados. */
export const sortByDateDesc = <T extends Record<string, any>>(
	items: T[],
	fields: string[] = ["date", "createdAt"]
): T[] =>
	[...items].sort((a, b) => {
		const timeA = Math.max(...fields.map((field) => getDateTime(a[field])));
		const timeB = Math.max(...fields.map((field) => getDateTime(b[field])));
		return timeB - timeA;
	});

/** Fecha larga con hora: "12 de Mayo 2024, 10:33". */
export const formatedDateTime = (value: any): string => {
	const date = parseDate(value);
	if (!date) return typeof value === "string" ? value : "";

	const hours = date.getHours().toString().padStart(2, "0");
	const minutes = date.getMinutes().toString().padStart(2, "0");

	return `${formatedDate(date.toISOString())}, ${hours}:${minutes}`;
};

// Acepta el enlace completo del tuit (x.com o twitter.com, con o sin
// parámetros) y devuelve solo el id, que es lo que necesita el embed.
// Si no reconoce un enlace devuelve el texto tal cual, para que se pueda
// seguir escribiendo en el campo y para no romper los ids ya guardados.
export function getTweetIdByUrl(value: string) {
	const match = value.match(/(?:twitter\.com|x\.com)\/[^/]+\/status(?:es)?\/(\d+)/);
	return match ? match[1] : value.trim();
}

// Un id de tuit es un número largo (18-19 dígitos hoy, pero los viejos son
// más cortos).
export const isTweetId = (value: string) => /^\d{10,25}$/.test(value);
